export default __webpack_public_path__ + "static/media/EI5-2.783536ae.jpg";